import {
  CommonModule,
  DatePipe,
  I18nPluralPipe,
  KeyValuePipe,
  TitleCasePipe,
} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbModule,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { LottieModule } from 'ngx-lottie';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SkeletonLoaderDirective } from './directives/skeleton-loader.directive';
import { SortableHeaderDirective } from './directives/sortable-header.directive';
import { ToastrModule } from 'ngx-toastr';
import player from 'lottie-web';

import { ChartComponent } from './components/chart/chart.component';
import { ChartDescriptionComponent } from './components/chart-description/chart-description.component';
import { EmailComponent } from './components/email/email.component';
import { FakeFillerPipe } from './pipes/fake-filler.pipe';
import { HeaderComponent } from './components/header/header.component';
import { HeaderLoginComponent } from './components/header-login/header-login.component';
import { MonthpickerComponent } from './components/monthpicker/monthpicker.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PairingPatientModalComponent } from './components/pairing-patient-modal/pairing-patient-modal.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { UnpairingPatientModalComponent } from './components/unpairing-patient-modal/unpairing-patient-modal.component';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    FakeFillerPipe,
    SkeletonLoaderDirective,
    SortableHeaderDirective,
    HeaderLoginComponent,
    SpinnerComponent,
    EmailComponent,
    HeaderComponent,
    PairingPatientModalComponent,
    UnpairingPatientModalComponent,
    PaginationComponent,
    ChartComponent,
    ChartDescriptionComponent,
    SpinnerComponent,
    MonthpickerComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbAccordionModule,
    NgbNavModule,
    NgSelectModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      preventDuplicates: false,
    }),
    LottieModule.forRoot({ player: playerFactory }),
  ],
  exports: [
    RouterModule,
    ToastrModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbModule,
    NgSelectModule,
    HeaderLoginComponent,
    HeaderComponent,
    SpinnerComponent,
    LottieModule,
    EmailComponent,
    FakeFillerPipe,
    SkeletonLoaderDirective,
    SortableHeaderDirective,
    PaginationComponent,
    ChartComponent,
    KeyValuePipe,
    DatePipe,
    TitleCasePipe,
    MonthpickerComponent,
    ChartDescriptionComponent,
    I18nPluralPipe,
  ],
  providers: [
    FakeFillerPipe,
    DatePipe,
    KeyValuePipe,
    TitleCasePipe,
    I18nPluralPipe,
  ],
})
export class SharedModule {}
